import { trackEvent } from '@feat/feat-tracking/event'
import type { TrackingCallback } from '@growthbook/growthbook-react'

export const initTracking: TrackingCallback = async (event, result) => {
  const eventParams = { experiment_id: event.key, variation_id: result.key }

  await new Promise(resolve => {
    trackEvent({
      event: 'experiment_viewed',
      ...eventParams,
      eventCallback: resolve,
    })
  })
}
